import { FONT_FAMILIES, FONT_WEIGHTS } from 'shared/constants/theme';
import { SHOP_TYPES } from '../blocks/shops/map/constants';

export const SYMBOL_TYPES = {
  ...SHOP_TYPES,
  CLUSTER: 'CLUSTER',
  HOME: 'HOME',
  USER: 'USER'
};

export const MARKER_STYLES = {
  size: { width: 24, height: 30 }
};

export const USER_MARKER_STYLES = {
  size: { width: 19, height: 19 },
  anchorIcon: [9.5, 9.5]
};

export const CLUSTER_STYLES = {
  textColor: 'black',
  textSize: 12,
  fontFamily: FONT_FAMILIES.brand,
  fontWeight: FONT_WEIGHTS.bold,
  anchorText: [-7, 0],
  width: 48,
  height: 64,
  anchorIcon: [64, 24]
};

export const CLUSTER_GRID_SIZE = 120;

export const ZOOM_LEVELS = {
  DEFAULT: 6,
  CLOSE: 10,
  SELECTED: 16,
  CLUSTER_MAX: 15 // Should be lower than SELECTED
};

export const BOUNDS_OFFSET = 0.005; // used to ensure a minimum offset around shops when computing their boundaries

export const MAP_OPTIONS = {
  styles: [] // default styles
};
export const DEFAULT_TRAVEL_MODE = 'DRIVING';
